export const LOGIN_COMPONENT= "LOGIN_COMPONENT"
export const FORGOT_PASSWORD= "FORGOT_PASSWORD"
export const SET_PASSWORD= "SET_PASSWORD"
